<template>
  <div class="page-title">
    <a-icon
      v-if="showSidebarButton"
      class="page-title__menu-toggle"
      type="menu"
      @click="toggleMenu"
    />
    <div class="page-title__wrap-header">
      <h1>{{ title }}</h1>

      <slot name="titleSuffix"></slot>

      <btn-export
        v-if="showExportBtn"
        :config="config"
        :filename='exportName'
        :columns="columns"
        :data="dataExport"
        :btnText="btnText"
        v-bind:btns="btns"
      />
    </div>
  </div>
</template>

<script>
import { bus } from '@/helpers';

export default {
  name: 'PageTitle',

  components: {
    BtnExport: () => import('@/components/base/BtnExport.vue'),
  },

  props: {
    btnText: {
      type: String,
      default: '',
      require: true,
    },
    exportName: {
      type: String,
      default: '',
      require: true,
    },
    title: {
      type: String,
      default: '',
    },
    showSidebarButton: {
      type: Boolean,
      default: true,
    },
    showExportBtn: {
      type: Boolean,
      default: false,
    },
    dataExport: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
    btns: {
      type: Array,
      require: false,
      default: () => {
        return [
          { label: 'Текущая страница XLSX', format: 'xlsx' },
          { label: 'Все данные CSV', format: 'csv' },
        ]
      },
    }
  },

  methods: {
    toggleMenu() {
      bus.$emit('toggleMenu');
    },
  },
};
</script>

<style lang="scss">
.page-title {
  min-height: 42px;

  &__wrap-header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .anticon {
    width: 30px;
    margin-right: 10px;
    margin-left: -6px;
    margin-bottom: -6px;
  }

  h1 {
    display: inline-block;
    font-size: 2.4rem;
    margin-bottom: 2rem;
    font-weight: 600;
  }

  &__menu-toggle {
    width: 30px;
    margin-right: 15px;
  }

  &:not(:first-child) &__menu-toggle {
    display: none;
  }
}

@media (min-width: $desktopBreakpoint) {
  .page-title {
    margin-top: 0;

    &__menu-toggle {
      display: none;
    }
  }
}
</style>
